module.exports = require("./dje");